<template>
    <div no-body > 
        <b-table
          class="mb-0"
          ref="tblCoa"
          responsive
          striped hover
          :items="getData"
          :fields="fields"
          :per-page="20"
          @row-clicked="selectItem"
        >
        <template v-slot:cell(nomor)="data">
          {{ data.index +1}}
        </template>
        <template v-slot:cell(address)="data">
          {{ data.item.compaddr1 }}
          {{ data.item.compaddr2 }}
          {{ data.item.compaddr3 }}
        </template>
        </b-table>
    </div>
</template>


<script>
import user from "../../apis/users";

export default {
  data() {
    return {
      fields: [
          {
            key: "nomor",
            thStyle: "width:50px",
            label: "No.",
          },
          {
            key: "company",
            label: "Company Name",
          },
          {
            key: "address",
            label: "Address",
          },
          {
            key: "PhoneNo",
            label: "Phone/Fax",
          },
      ],
    };
  },
  methods: {
    getData: async function(ctx) {
      const companies=await user.company();
      return companies;      
    },
    selectItem(item,index) {
        this.$emit("click", item);
    },  
    refresh() {
      this.$refs.tblCoa.refresh();
    }
  }
};
</script>
